var React = require('react');

function FlagCg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 88.276H361.931L2.703 421.218c1.589 1.539 3.737 2.506 6.124 2.506h141.241L509.297 90.782c-1.589-1.54-3.738-2.506-6.125-2.506z","fill":"#ffe15a","key":0}),React.createElement("path",{"d":"M361.931 88.276H8.828A8.828 8.828 0 000 97.103v317.793c0 2.488 1.047 4.717 2.703 6.322L361.931 88.276z","fill":"#73af00","key":1}),React.createElement("path",{"d":"M509.297 90.782L150.069 423.724h353.103a8.829 8.829 0 008.828-8.828V97.103c0-2.489-1.047-4.717-2.703-6.321z","fill":"#ff4b55","key":2})]);
}

FlagCg.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = FlagCg;

FlagCg.default = FlagCg;
